const CAR_TYPES = [
  "เดินมา",
  "รถกระบะ",
  "รถเก๋ง",
  "รถพ่วง",
  "รถพวงข้าง",
  "รถตู้",
  "รถ6ล้อ",
  "รถ10ล้อ",
  "รถจักรยานยนต์",
];
export default CAR_TYPES;
